import classNames from "classnames";
import React, { ElementType, ReactNode } from "react";
import { pushCTAClick } from "../../utils/dataLayer";
import { detectHTMLZone } from "../../hooks/useHTMLZone";

type Props<Tag extends keyof JSX.IntrinsicElements> = {
  tag?: ElementType | keyof JSX.IntrinsicElements;
  children?: ReactNode;
  variant:
    | "primary"
    | "secondary"
    | "naked"
    | "light"
    | "line"
    | "icon"
    | "data";
  disabled?: boolean;
  size?: "sm" | "md" | "lg" | "data";
  className?: string;
  onClick?: Function;
  trackCTA?: boolean;
  ctaName?: string;
} & JSX.IntrinsicElements[Tag];

const Button = ({
  tag: Tag = "button",
  size = "lg",
  variant = "primary",
  className = "",
  disabled,
  onClick = () => {},
  children,
  trackCTA = true, // Track by default
  ctaName,
  ...props
}: Props<any>) => {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (trackCTA && !disabled) {
      const ctaText =
        ctaName || (typeof children === "string" ? children : "CTA");
      const htmlZone = detectHTMLZone(e.currentTarget);
      pushCTAClick(ctaText, htmlZone);
    }
    onClick(e);
  };

  return (
    <Tag
      className={classNames(
        `btn ${variant} ${size} disabled:opacity-75 select-none`,
        className,
      )}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default Button;
